import { render, staticRenderFns } from "./PaintlistforcolorPage.vue?vue&type=template&id=27ec83fc"
import script from "./PaintlistforcolorPage.vue?vue&type=script&lang=js"
export * from "./PaintlistforcolorPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports